import { EventBus } from '@/event-bus.js';
import { GRUPOS, VISTAS, ACCIONES, CONFIGURACION, CONFIG_SECCIONES, DOCUMENTOS, REPORTES, FILTROS_SECUNDARIOS_CIERRE_VIAJE, normalizarContexto, filtrosIniciales, prepararFiltros,
  identidad, claveFila, tieneValor, cerrado, fiscalElectronico, esVerdadero, simple, textoError, formatear, csv, nuevoIdSolicitud, fechaFormulario, fechaValida, filtrosIgnoradosTickets, filtrosIgnoradosEnvios } from './catalogo';
import { crearApi, ajustesImpresora, listarImpresoras, postImpresoraLocal } from './api';
import { PESTANAS_CONFIG, CONFIG_CAJA_INICIAL, seccionConfiguracion, columnasConfiguracion, camposDetalleConfiguracion } from './configuracion';
import { evaluarAsignacion } from './arreglosEnvios';

const clonar = valor => JSON.parse(JSON.stringify(valor));
export default {
  data() {
    return { grupos: GRUPOS, vistas: VISTAS, contexto: { vistas: {}, permisos: {}, catalogos: {} }, contextoListo: false,
      cargandoContexto: false, vistaId: '', filtros: {}, memoria: {}, filtrosAplicados: {}, filtrosSucios: false,
      filas: [], total: 0, pagina: 1, tamano: 50, resumen: null, seleccion: [], detalle: null, detalleFila: null,
      seleccionEnvios: {}, filaDetalleActual: null, desmarcarAutomaticamente: false, excluidosAsignacion: [], resultadosAsignacion: [],
      filtrosConsumo: { desde: '', hasta: '', orden: 'fecha_presentacion', direccion: 'asc' }, consumosSucios: false,
      dialogoReportePdf: false, reportePdfBlob: null,
      dialogoDetalle: false, dialogoFirma: false, dialogoNotaCredito: false, notaCreditoSeleccionada: null, errorDetalle: '', campoTurno: '', turnosSeleccionados: {},
      cargando: false, cargandoDetalle: false, guardando: false, exportando: false, imprimiendo: false, detallePagina: 1,
      peticion: 0, peticionDetalle: 0, destruido: false, mensaje: '', tipoMensaje: 'error',
      dialogo: false, accion: null, edicion: {}, edicionOriginal: {}, motivo: '', confirmarCerrado: false, errorAccion: '', avisoFiscal: false, incierta: false, idSolicitud: '', firmaSolicitud: '',
      destinatarios: [], ordenCambiado: false, impresora: '', impresoras: [], impresorasCargadas: false, impresoraPredeterminada: '', cargandoImpresoras: false,
      dialogoImpresion: false, errorImpresion: '', impresionIncierta: false, requiereSinQr: false, confirmarSinQr: false,
      modoImpresion: 'documento', formatoImpresion: '', salidaImpresion: 'preview', enviarDirecto: false, copias: 0,
      dialogoAuditoria: false, auditoriaFilas: [], auditoriaPagina: 0, auditoriaTotal: 0, cargandoAuditoria: false, errorAuditoria: '' };
  },
  computed: {
    vista() { return this.vistas.find(v => v.id === this.vistaId) || null; },
    meta() {
      const meta = this.contexto.vistas[this.vistaId] || { filtros: [], columnas: [] };
      return this.vistaId === 'config' ? { ...meta, columnas: columnasConfiguracion(this.seccionConfig) } : meta;
    },
    pestanasConfig() { return PESTANAS_CONFIG; },
    permiteOrdenarColumnas() { return ['envios', 'arreglos-envios', 'cortesias', 'turnos', 'notas-credito'].includes(this.vistaId) || this.vistaId === 'config' && this.seccionConfig === 'cajas'; },
    catalogosFiltros() {
      if (this.vistaId !== 'notas-credito' || !tieneValor(this.filtros.sucursal)) return this.contexto.catalogos;
      return { ...this.contexto.catalogos, cajas: (this.contexto.catalogos.cajas || []).filter(c => String(c.sucursal) === String(this.filtros.sucursal)) };
    },
    pestanaConfig() { return seccionConfiguracion(this.filtros.seccion); },
    filtrosVisibles() {
      return this.vistaId !== 'config' ? this.meta.filtros : this.meta.filtros.filter(f =>
        this.pestanaConfig === 'cajas' && ['caja', 'sucursal'].includes(f.campo) || this.pestanaConfig === 'comisiones' && f.campo === 'sucursal');
    },
    valoresDetalleConfig() {
      if (!this.detalle) return {};
      const valores = { ...this.detalle.registro };
      const rangos = this.detalle.detalles && this.detalle.detalles.rangos;
      if (rangos) valores.rangos = rangos.filas;
      return valores;
    },
    camposDetalleConfig() { return camposDetalleConfiguracion(this.seccionConfig, this.valoresDetalleConfig); },
    dependenciaAusente() { return (this.contexto.dependenciasNoDisponibles || []).find(d => d.vista === this.vistaId); },
    permisos() { return this.contexto.permisos; },
    ocupado() { return this.guardando || this.imprimiendo || this.exportando || !!this.campoTurno; },
    soloOrden() { return ['reordenar-turnos', 'sucursales'].includes(this.vistaId); },
    conjuntoCompleto() { return this.soloOrden || this.vistaId === 'config' && this.seccionConfig === 'comisiones'; },
    seccionConfig() { return this.filtrosAplicados.seccion === 'caja' ? 'cajas' : this.filtrosAplicados.seccion || 'sistema'; },
    ordenCompleto() { return this.filas.length > 0 && this.total === this.filas.length && this.pagina === 1; },
    seleccionadas() { return this.vistaId === 'arreglos-envios'
      ? this.seleccion.map(k => this.seleccionEnvios[k] || this.filas.find(f => claveFila(this.vistaId, f) === k)).filter(Boolean)
      : this.filas.filter(f => this.seleccion.includes(claveFila(this.vistaId, f))); },
    paginaSeleccionada() { return this.filas.length > 0 && this.filas.every(f => this.seleccion.includes(claveFila(this.vistaId, f))); },
    paginaParcial() { return !this.paginaSeleccionada && this.filas.some(f => this.seleccion.includes(claveFila(this.vistaId, f))); },
    usuarioDestinoAsignacion() { return (this.contexto.catalogos.usuarios || []).find(u => u.activo && String(u.valor) === String(this.edicion.usuario)) || null; },
    previsionAsignacion() { return this.destinatarios.map(f => evaluarAsignacion(f, this.usuarioDestinoAsignacion, this.confirmarCerrado)); },
    acciones() {
      return ACCIONES.filter(a => a.vistas.includes(this.vistaId) && (!a.secciones || a.secciones.includes(this.seccionConfig)) && this.permisos[a.permiso] === true &&
        (this.meta.acciones === null ? !a.extension : (this.meta.acciones || []).includes(a.id)));
    },
    esRegistro() { return this.vista && this.vista.grupo === 2; },
    accionEditarRegistro() {
      return this.esRegistro ? this.acciones.find(a => a.configuracion || a.valores) || null : null;
    },
    tituloDialogoAccion() {
      if (!this.accion) return '';
      if (!this.esRegistro) return this.accion.titulo;
      const titulo = this.accion.nuevo && !this.destinatarios.length ? this.accion.tituloNuevo : this.accion.titulo;
      const registro = this.destinatarios[0] || {};
      if (this.vistaId !== 'config') {
        const nombre = this.vistaId === 'fichas' ? [registro.ficha, registro.descripcion].filter(tieneValor).join(' - ') : registro.nombre || registro.descripcion;
        return nombre ? titulo + ' - ' + nombre : titulo;
      }
      if (this.seccionConfig !== 'cajas') return titulo;
      const caja = (this.contexto.catalogos.cajas || []).find(c => String(c.valor) === String(registro.idcaja || this.filtrosAplicados.caja));
      const nombre = registro.descripcion || caja && caja.titulo;
      return nombre ? titulo + ' - ' + nombre : titulo;
    },
    camposAccion() {
      if (!this.accion) return [];
      const campos = this.accion.configuracion ? CONFIGURACION.filter(c => (CONFIG_SECCIONES[this.seccionConfig] || []).includes(c.campo) && Object.prototype.hasOwnProperty.call(this.edicion, c.campo)) : this.accion.campos || [];
      return campos.map(c => {
        if (this.accion.id === 'turno-modificar') return { ...c, catalogo: '', opciones: (this.contexto.catalogos[c.catalogo] || []).filter(o => o.activo) };
        if (this.accion.id === 'envio-usuario' && c.campo === 'usuario') return { ...c, titulo: 'Cajero destino', catalogo: '',
          opciones: (this.contexto.catalogos.usuarios || []).filter(u => u.activo).map(u => ({ ...u, titulo: u.titulo + ' (' + u.valor + ') - ' + u.nombreSucursal })) };
        if (this.accion.registro && c.catalogo) {
          const opciones = (this.contexto.catalogos[c.catalogo] || []).slice();
          const registro = this.destinatarios[0] || {};
          const valor = registro[c.fuente || c.campo];
          if (tieneValor(valor) && !opciones.some(o => String(o.valor) === String(valor))) {
            const nombre = c.campo === 'conductor' ? registro.conductor : c.campo === 'propietario' ? registro.nombre_propietario : c.campo === 'sucursal_salida' ? registro.nombre_salida : registro.nombre_llegada;
            opciones.unshift({ valor, titulo: nombre || String(valor) });
          }
          return { ...c, catalogo: '', opciones };
        }
        if (!['impresora_tickets', 'impresora_etiquetas'].includes(c.campo)) return c;
        const opciones = this.impresoras.map(i => ({ valor: i.nombre, titulo: i.nombre }));
        const registro = this.destinatarios[0] || {};
        const guardada = (registro.valores || registro)[c.campo];
        // Otra caja puede tener una impresora que no esta instalada en la PC administrativa.
        if (typeof guardada === 'string' && guardada.trim() && !opciones.some(o => o.valor === guardada)) opciones.unshift({ valor: guardada, titulo: guardada });
        for (const nombre of ['tickets', 'etiquetas']) if (!opciones.some(o => o.valor === nombre)) opciones.push({ valor: nombre, titulo: nombre });
        return { ...c, tipo: 'combobox', opciones };
      });
    },
    cierreAfectado() { return this.destinatarios.some(cerrado) || this.accion && this.accion.id === 'cierre-viaje-eliminar'; },
    cancelacionEnvioElectronico() { return this.accion && this.accion.id === 'envio-cancelar' && this.destinatarios.some(fiscalElectronico); },
    cancelacionBoletoElectronico() { return this.accion && this.accion.id === 'ticket-cancelar' && this.destinatarios.some(fiscalElectronico); },
    envioRecibidoYEntregado() { return this.destinatarios.some(f => esVerdadero(f.is_recibido) && esVerdadero(f.is_recogido)); },
    esDocumento() { return DOCUMENTOS.includes(this.vistaId); },
    tieneReporte() { return Object.prototype.hasOwnProperty.call(REPORTES, this.vistaId); },
    formatosImpresion() { return REPORTES[this.vistaId] || []; },
    puedeReimprimir() { return this.esDocumento && this.permisos.reimprimir === true && !this.filtrosSucios && !this.cargando && this.seleccionadas.length === 1; },
    puedeReporte() { return this.tieneReporte && this.permisos.reimprimir === true && !this.filtrosSucios && !this.cargando && this.total > 0; },
    puedeImprimir() { return this.modoImpresion === 'listado' ? this.puedeReporte : this.puedeReimprimir; },
    paginas() { return Math.max(1, Math.ceil(this.total / this.tamano)); },
    esDetalleDocumento() { return ['tickets', 'envios', 'arreglos-envios', 'cortesias', 'turnos', 'cierres-caja', 'cierres-viaje', 'config'].includes(this.vistaId); },
    tituloDetalle() { return ({ tickets: 'Detalle del ticket', envios: 'Detalle del envio', 'arreglos-envios': 'Detalle del envio', cortesias: 'Detalle de cortesia', turnos: 'Detalle del turno', 'cierres-caja': 'Detalle del cierre de caja', 'cierres-viaje': 'Detalle del cierre de viaje', config: 'Configuraciones - ' + (PESTANAS_CONFIG.find(p => p.valor === this.seccionConfig) || {}).titulo })[this.vistaId] || 'Detalle'; },
    filtrosIgnorados() {
      if (this.vistaId === 'tickets') return filtrosIgnoradosTickets(this.meta, this.filtros);
      if (this.vistaId === 'envios') return filtrosIgnoradosEnvios(this.meta, this.filtros);
      return this.vistaId === 'cierres-viaje' && tieneValor(this.filtros.id) && String(this.filtros.id).trim() !== '' ? FILTROS_SECUNDARIOS_CIERRE_VIAJE : [];
    },
    autorizacionesTicket() { return this.vistaId === 'tickets' && this.detalle && this.detalle.detalles && this.detalle.detalles.autorizaciones || null; },
    accionAutorizacion() { return this.accion && ['reimpresion-autorizar', 'reimpresion-quitar'].includes(this.accion.id); },
    puedeQuitarAutorizacion() { return this.accionDisponible(this.acciones.find(a => a.id === 'reimpresion-quitar')); },
    resumenTickets() {
      return ['abordados', 'no_abordados', 'cancelados'].map((estado, i) => ({ estado: ['Abordados', 'No abordados', 'Cancelados'][i],
        cantidad: this.resumen && this.resumen['cantidad_' + estado], importe: this.resumen && this.resumen['monto_' + estado] }));
    },
    resumenEnvios() {
      return ['entregados', 'no_entregados', 'cancelados', 'total', 'recargos'].map((estado, i) => ({ estado: ['Entregados', 'No entregados', 'Cancelados', 'Total', 'Recargos'][i],
        cantidad: this.resumen && this.resumen['cantidad_' + estado], importe: this.resumen && this.resumen[estado === 'total' ? 'precio_total' : 'monto_' + estado] }));
    },
    firmaEnvio() {
      const firma = this.detalle && this.detalle.firma;
      return typeof firma === 'string' && /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/=\r\n]+$/.test(firma) ? firma : '';
    },
    detalleSiguiente() { return this.detalle && this.detalle.detalles && Object.values(this.detalle.detalles).some(d => d && Number(d.total) > this.detallePagina * (Number(d.tamano) || 50)); },
    opcionesImpresoras() {
      const nombres = this.impresoras.map(i => ({ valor: i.nombre, titulo: i.nombre + (i.nombre === this.impresoraPredeterminada ? ' (predeterminada)' : '') }));
      if (!this.impresorasCargadas && this.impresora && !nombres.some(i => i.valor === this.impresora)) nombres.unshift({ valor: this.impresora, titulo: this.impresora });
      return [{ valor: '', titulo: 'Predeterminada de Windows' }, ...nombres];
    },
  },
  watch: {
    'edicion.usuario'() { this.aplicarDesmarcado(); },
    desmarcarAutomaticamente() { this.aplicarDesmarcado(); },
  },
  mounted() { this.actualizarBarra(); this.cargarContexto(); },
  beforeDestroy() { this.destruido = true; this.peticion++; this.peticionDetalle++; },
  methods: {
    formatear, identidad, claveFila,
    limpiarSeleccion() { this.seleccion = []; this.seleccionEnvios = {}; },
    aplicarDesmarcado() {
      if (this.guardando || !this.dialogo || !this.accion || this.accion.id !== 'envio-usuario' || !this.desmarcarAutomaticamente || !this.usuarioDestinoAsignacion) return;
      const excluidos = this.previsionAsignacion.filter(f => f.desmarcable);
      if (!excluidos.length) return;
      const ids = new Set(excluidos.map(f => String(f.id)));
      this.excluidosAsignacion.push(...excluidos.map(f => ({ ...f, estado: 'DESMARCADO' })));
      this.destinatarios = this.destinatarios.filter(f => !ids.has(String(f.id)));
      this.seleccion = this.seleccion.filter(k => !ids.has(String((this.seleccionEnvios[k] || {}).id)));
      const restantes = {}; this.seleccion.forEach(k => { restantes[k] = this.seleccionEnvios[k]; }); this.seleccionEnvios = restantes;
    },
    icono(vista) { return (process.env.BASE_URL || '/').replace(/\/?$/, '/') + 'iconos_utilitario/' + encodeURIComponent(vista.icono); },
    actualizarBarra() {
      EventBus.$emit('anularBotonesAccion', { titulo: this.vista ? 'Utilitario / ' + this.vista.titulo : 'Utilitario',
        descripcion: 'Transportacion', save: false, eliminar: false, anular: false, nuevo: false, imprimir: false,
        vercuenta: false, Transp: true, btnBarraDi: false, accion: [] });
    },
    async cargarContexto() {
      if (this.cargandoContexto || this.ocupado) return;
      this.cargandoContexto = true; this.contextoListo = false; this.mensaje = '';
      this.contexto = { vistas: {}, permisos: {}, catalogos: {} }; this.turnosSeleccionados = {}; this.campoTurno = '';
      try {
        const contexto = normalizarContexto(await crearApi(this).contexto());
        if (this.destruido) return;
        this.contexto = contexto; this.contextoListo = true;
        if (!contexto.permisos.consultar) this.mostrarError(new Error('No tiene permiso para consultar el utilitario.'));
      } catch (error) { if (!this.destruido) this.mostrarError(error); }
      finally { if (!this.destruido) this.cargandoContexto = false; }
    },
    disponible(id) { return this.contextoListo && this.permisos.consultar === true && !!this.contexto.vistas[id]; },
    async abrirVista(id) {
      if (this.ocupado || this.dialogo || this.dialogoImpresion || !this.disponible(id)) return;
      this.guardarFiltros(); this.invalidarDetalle(); this.peticion++;
      this.vistaId = id; this.filas = []; this.limpiarSeleccion(); this.resultadosAsignacion = []; this.total = 0; this.resumen = null; this.mensaje = '';
      const memoria = id === 'notas-credito' ? null : this.memoria[id];
      this.filtros = memoria ? clonar(memoria.filtros) : filtrosIniciales(this.meta);
      this.tamano = memoria ? memoria.tamano : this.soloOrden ? 200 : 50; this.pagina = 1; this.ordenCambiado = false;
      this.actualizarBarra(); await this.consultar(1);
    },
    guardarFiltros() { if (this.vistaId) this.$set(this.memoria, this.vistaId, { filtros: clonar(this.filtros), tamano: this.tamano }); },
    volver() {
      if (this.ocupado || this.dialogo || this.dialogoImpresion) return;
      this.guardarFiltros(); this.peticion++; this.invalidarDetalle(); this.cargando = false;
      this.vistaId = ''; this.filas = []; this.limpiarSeleccion(); this.resultadosAsignacion = []; this.resumen = null; this.mensaje = ''; this.actualizarBarra();
    },
    cambiarFiltro(campo, valor) {
      if (this.ocupado || this.dialogo || this.dialogoImpresion || this.cargando || !this.meta.filtros.some(f => f.campo === campo)) return;
      this.$set(this.filtros, campo, valor); this.filtrosSucios = true; this.limpiarSeleccion(); this.resultadosAsignacion = []; this.invalidarDetalle();
      if (this.vistaId === 'notas-credito' && campo === 'sucursal') this.$set(this.filtros, 'caja', '');
      if (this.vistaId === 'turnos' && tieneValor(valor)) {
        if (campo === 'fecha') { this.$set(this.filtros, 'desde', ''); this.$set(this.filtros, 'hasta', ''); }
        if (['desde', 'hasta'].includes(campo)) this.$set(this.filtros, 'fecha', '');
      }
      if (this.vistaId === 'envios' && campo === 'agrupacion') {
        this.$set(this.filtros, 'orden', ''); this.$set(this.filtros, 'direccion', '');
        return this.consultar(1);
      }
      if (this.vistaId === 'config' && campo === 'seccion') { this.$set(this.filtros, 'caja', ''); this.$set(this.filtros, 'sucursal', ''); this.$set(this.filtros, 'orden', ''); this.$set(this.filtros, 'direccion', ''); }
    },
    esFiltroTurno(campo) { return this.vistaId === 'turnos' && campo === 'id' || this.vistaId === 'tickets' && ['turno_detalle', 'turno_abordado'].includes(campo) || this.vistaId === 'envios' && campo === 'turno_detalle'; },
    async ordenarEnvios(columna) {
      if (!this.permiteOrdenarColumnas || this.ocupado || this.cargando || this.dialogo || this.dialogoImpresion || this.filtrosSucios || !this.meta.columnas.some(c => c.campo === columna)) return;
      const direccion = this.filtros.orden === columna && this.filtros.direccion === 'asc' ? 'desc' : 'asc';
      this.$set(this.filtros, 'orden', columna); this.$set(this.filtros, 'direccion', direccion);
      await this.consultar(1);
    },
    textoTurno(campo) {
      const id = this.filtros[campo];
      return tieneValor(id) ? this.turnosSeleccionados[id] || 'Turno ' + id : '';
    },
    abrirBuscadorTurno(campo) {
      if (!this.esFiltroTurno(campo) || this.ocupado || this.cargando || this.dialogo || this.dialogoImpresion || this.filtrosIgnorados.includes(campo)) return;
      this.campoTurno = campo;
    },
    async consultarTurnos(filtros) {
      try { return await crearApi(this).consulta('turnos', filtros); }
      catch (error) { this.revocarSiDenegado(error); throw error; }
    },
    async seleccionarTurno(fila) {
      const campo = this.campoTurno;
      if (!this.esFiltroTurno(campo) || !Number.isInteger(Number(fila.id)) || Number(fila.id) <= 0) return;
      this.campoTurno = '';
      this.$set(this.turnosSeleccionados, fila.id, fila.numero_viaje);
      if (this.vistaId === 'turnos') {
        this.filtros = Object.fromEntries(this.meta.filtros.map(f => [f.campo, '']));
        this.cambiarFiltro('id', Number(fila.id));
        if (!await this.consultar(1) || this.vistaId !== 'turnos') return;
        const elegido = this.filas.find(f => String(f.id) === String(fila.id));
        if (!elegido) return;
        this.elegirFila(elegido);
        const accion = this.acciones.find(a => a.id === 'turno-modificar');
        if (this.accionDisponible(accion)) await this.abrirAccion(accion);
        else await this.verDetalle(1);
        return;
      }
      this.cambiarFiltro(campo, Number(fila.id));
    },
    async cambiarSeccionConfig(valor) {
      if (this.ocupado || this.cargando || this.cargandoDetalle || this.dialogo || this.dialogoImpresion || this.vistaId !== 'config') return;
      if (!PESTANAS_CONFIG.some(p => p.valor === valor)) return;
      this.cambiarFiltro('seccion', valor === 'cajas' ? 'caja' : valor); this.filas = []; this.total = 0;
      await this.consultar(1);
    },
    limpiarFiltros() {
      if (this.ocupado || this.cargando || this.dialogo || this.dialogoImpresion) return;
      const seccion = this.filtros.seccion;
      this.filtros = filtrosIniciales(this.meta);
      if (this.vistaId === 'arreglos-envios') { this.filtros.desde = ''; this.filtros.hasta = ''; }
      if (this.vistaId === 'config') this.filtros.seccion = seccion || 'sistema';
      this.filtrosSucios = true; this.limpiarSeleccion(); this.resultadosAsignacion = []; this.invalidarDetalle();
    },
    limpiarFechasArreglos() {
      if (this.vistaId !== 'arreglos-envios' || this.ocupado || this.cargando || this.dialogo) return;
      this.cambiarFiltro('desde', ''); this.cambiarFiltro('hasta', '');
    },
    async consultar(pagina = 1, conservarSeleccion = this.vistaId === 'arreglos-envios' && !this.filtrosSucios) {
      if (!this.disponible(this.vistaId) || this.ocupado || this.dialogo || this.dialogoImpresion) return false;
      let filtros;
      try { filtros = prepararFiltros(this.meta, this.filtros, pagina, this.tamano); }
      catch (error) { this.mostrarError(error); return false; }
      const token = ++this.peticion; const vista = this.vistaId;
      this.cargando = true; this.mensaje = ''; if (!conservarSeleccion) this.limpiarSeleccion(); this.invalidarDetalle(); this.ordenCambiado = false;
      try {
        const data = await crearApi(this).consulta(vista, filtros);
        if (token !== this.peticion || this.destruido) return false;
        if (!data || !Array.isArray(data.filas) || !Number.isFinite(Number(data.total)) || Number(data.total) < 0 || data.filas.length > 200) throw new Error('El servidor devolvio un listado invalido.');
        this.filas = data.filas.filter(r => r && typeof r === 'object' && !Array.isArray(r));
        if (vista === 'arreglos-envios') this.filas.forEach(f => { const k = claveFila(vista, f); if (this.seleccion.includes(k)) this.$set(this.seleccionEnvios, k, f); });
        this.total = Number(data.total); this.pagina = Number(data.pagina) || filtros.pagina; this.tamano = Number(data.tamano) || filtros.tamano;
        this.resumen = data.resumen || null; this.filtrosAplicados = filtros; this.filtrosSucios = false; this.incierta = false;
        this.guardarFiltros(); return true;
      } catch (error) {
        if (token === this.peticion && !this.destruido) { this.filas = []; this.total = 0; this.resumen = null; this.mostrarError(error); }
        return false;
      } finally { if (token === this.peticion && !this.destruido) this.cargando = false; }
    },
    async cargarOrdenCompleto() {
      if (!this.conjuntoCompleto || !this.disponible(this.vistaId) || this.cargando || this.ocupado || this.filtrosSucios) return;
      const token = ++this.peticion; this.cargando = true; this.seleccion = []; this.invalidarDetalle();
      try {
        if (this.total > 1000) throw new Error('El conjunto supera 1000 registros; no se puede modificar como un solo lote.');
        const filas = []; const total = this.total;
        for (let pagina = 1; filas.length < total; pagina++) {
          const data = await crearApi(this).consulta(this.vistaId, { ...this.filtrosAplicados, pagina, tamano: 200 });
          if (token !== this.peticion || this.destruido) return;
          if (!data || !Array.isArray(data.filas) || !data.filas.length || Number(data.total) !== total || data.filas.length > 200 || pagina > 5) throw new Error('El listado cambio. Consulte nuevamente antes de reordenar.');
          filas.push(...data.filas);
        }
        if (filas.length !== total || new Set(filas.map(f => claveFila(this.vistaId, f))).size !== total) throw new Error('El orden contiene registros duplicados o incompletos.');
        this.filas = filas; this.pagina = 1; this.tamano = 2000; this.ordenCambiado = false;
      } catch (error) { if (token === this.peticion) this.mostrarError(error); }
      finally { if (token === this.peticion && !this.destruido) this.cargando = false; }
    },
    seleccionarRegistro(fila, multiple = false) {
      if (this.vistaId === 'cortesias' && this.seleccion.includes(claveFila(this.vistaId, fila))) return;
      this.elegirFila(fila, multiple);
      if (this.vistaId === 'cortesias' && this.seleccion.includes(claveFila(this.vistaId, fila))) return this.verDetalle(1, false);
    },
    cambiarFiltroConsumo(campo, valor) {
      if (this.vistaId !== 'cortesias' || this.ocupado || this.cargandoDetalle || !['desde', 'hasta'].includes(campo)) return;
      this.$set(this.filtrosConsumo, campo, valor || ''); this.consumosSucios = true; this.detalle = null; this.errorDetalle = '';
    },
    limpiarFechasConsumo() { this.cambiarFiltroConsumo('desde', ''); this.cambiarFiltroConsumo('hasta', ''); },
    ordenarConsumos(campo) {
      if (this.ocupado || this.cargandoDetalle || this.consumosSucios || !['id', 'fecha_presentacion', 'ruta', 'precio', 'persona'].includes(campo)) return;
      this.filtrosConsumo.direccion = this.filtrosConsumo.orden === campo && this.filtrosConsumo.direccion === 'asc' ? 'desc' : 'asc';
      this.filtrosConsumo.orden = campo; return this.consultarConsumos(1);
    },
    consultarConsumos(pagina = 1) { if (this.vistaId === 'cortesias') return this.verDetalle(pagina, this.dialogoDetalle); },
    cerrarDetalle() { if (this.vistaId === 'cortesias') this.dialogoDetalle = false; else this.invalidarDetalle(); },
    elegirFila(fila, multiple = false) {
      if (this.ocupado || this.cargando || this.dialogo || this.dialogoImpresion || this.filtrosSucios || !this.filas.includes(fila) || !tieneValor(identidad(this.vistaId, fila))) return;
      const key = claveFila(this.vistaId, fila);
      if (this.vistaId === 'arreglos-envios') {
        multiple = true;
        if (!this.seleccion.includes(key) && this.seleccion.length >= 1000) { this.mostrarError(new Error('Puede seleccionar hasta 1000 envios por lote.')); return; }
        this.$set(this.seleccionEnvios, key, fila);
      }
      this.seleccion = multiple ? (this.seleccion.includes(key) ? this.seleccion.filter(k => k !== key) : [...this.seleccion, key]) : [key];
      this.invalidarDetalle();
    },
    async detalleDobleClic(fila) {
      if (this.vistaId === 'notas-credito') {
        if (this.ocupado || this.cargando || this.filtrosSucios || !this.permisos.reimprimir) return;
        this.elegirFila(fila); this.abrirNotaCredito(); return;
      }
      if (this.vistaId === 'config') {
        if (this.puedeEditarRegistro(fila)) return this.editarRegistro(fila);
        if (this.ocupado || this.cargando || this.cargandoDetalle || this.filtrosSucios || this.dialogo || this.dialogoImpresion) return;
        this.elegirFila(fila); return this.verDetalle(1);
      }
      if (this.vistaId === 'cortesias' && !this.ocupado && !this.cargando && !this.filtrosSucios && !this.dialogo && !this.dialogoImpresion) {
        if (this.cargandoDetalle && this.seleccion.includes(claveFila(this.vistaId, fila))) { this.dialogoDetalle = true; return; }
        this.elegirFila(fila); return this.verDetalle(1);
      }
      if (!['tickets', 'envios', 'arreglos-envios', 'turnos'].includes(this.vistaId) || this.ocupado || this.cargando || this.filtrosSucios || this.dialogo || this.dialogoImpresion || this.cargandoDetalle) return;
      if (this.vistaId === 'arreglos-envios') { await this.verDetalle(1, true, fila); return; }
      this.elegirFila(fila);
      await this.verDetalle(1);
    },
    abrirNotaCredito() {
      if (this.seleccionadas.length !== 1 || this.ocupado || this.cargando || this.filtrosSucios || !this.permisos.reimprimir) return;
      this.notaCreditoSeleccionada = { ...this.seleccionadas[0] };
      this.dialogoNotaCredito = true;
    },
    async quitarAutorizacion(fila) {
      const accion = this.acciones.find(a => a.id === 'reimpresion-quitar');
      if (!this.accionDisponible(accion) || !this.autorizacionesTicket || !this.autorizacionesTicket.filas.includes(fila)) return;
      await this.abrirAccion(accion);
      if (this.dialogo && this.accion === accion) this.$set(this.edicion, 'caja', fila.caja);
    },
    seleccionarPagina(valor) {
      if (this.ocupado || this.cargando || this.dialogo || this.dialogoImpresion || this.filtrosSucios) return;
      const claves = this.filas.filter(f => tieneValor(identidad(this.vistaId, f))).map(f => claveFila(this.vistaId, f));
      const seleccion = valor ? Array.from(new Set([...this.seleccion, ...claves])) : this.seleccion.filter(k => !claves.includes(k));
      if (seleccion.length > 1000) { this.mostrarError(new Error('Puede seleccionar hasta 1000 envios por lote.')); return; }
      this.filas.forEach(f => this.$set(this.seleccionEnvios, claveFila(this.vistaId, f), f)); this.seleccion = seleccion;
      this.invalidarDetalle();
    },
    invalidarDetalle() { this.peticionDetalle++; this.detalle = null; this.detalleFila = null; this.filaDetalleActual = null; this.cargandoDetalle = false; this.detallePagina = 1; this.dialogoDetalle = false; this.dialogoFirma = false; this.errorDetalle = ''; this.consumosSucios = false; },
    async verFirma() {
      if (this.vistaId !== 'envios' || this.seleccionadas.length !== 1) return;
      if (await this.verDetalle(1, false)) this.dialogoFirma = true;
    },
    async verDetalle(pagina = 1, mostrar = true, filaExplicita = null) {
      const elegida = filaExplicita || (this.dialogoDetalle && this.filaDetalleActual);
      if (!elegida && this.seleccionadas.length !== 1 || this.ocupado || this.cargandoDetalle || this.filtrosSucios || !this.disponible(this.vistaId)) return false;
      const fila = elegida || this.seleccionadas[0]; const token = ++this.peticionDetalle; this.filaDetalleActual = fila;
      this.cargandoDetalle = true; this.detalle = null; this.errorDetalle = '';
      this.detallePagina = pagina;
      this.dialogoDetalle = mostrar && this.esDetalleDocumento;
      try {
        const parametros = { ...this.filtrosAplicados, pagina_detalle: pagina, tamano_detalle: 50 };
        delete parametros.pagina; delete parametros.tamano;
        if (this.vistaId === 'cortesias') {
          const { desde, hasta, orden, direccion } = this.filtrosConsumo;
          if ([desde, hasta].some(f => f && !fechaValida(f))) throw new Error('Fecha de consumo invalida.');
          if (desde && hasta && desde > hasta) throw new Error('La fecha desde no puede ser posterior a hasta.');
          Object.assign(parametros, { desde_consumo: desde, hasta_consumo: hasta, orden_consumo: orden, direccion_consumo: direccion });
        }
        const data = await crearApi(this).detalle(this.vistaId, identidad(this.vistaId, fila), parametros);
        if (token !== this.peticionDetalle || this.destruido) return false;
        if (!data || !data.registro || typeof data.registro !== 'object') throw new Error('El servidor no devolvio el detalle del registro.');
        this.detalle = data; this.detalleFila = claveFila(this.vistaId, fila); this.detallePagina = pagina; this.consumosSucios = false; return true;
      } catch (error) {
        if (token === this.peticionDetalle && !this.destruido) {
          if (this.dialogoDetalle || this.vistaId === 'cortesias') { this.errorDetalle = textoError(error); this.revocarSiDenegado(error); }
          else this.mostrarError(error);
        }
        return false;
      }
      finally { if (token === this.peticionDetalle && !this.destruido) this.cargandoDetalle = false; }
    },
    accionDisponible(accion, nuevo = false) {
      if (!this.contexto.auditoriaDisponible || !accion || !this.acciones.some(a => a.id === accion.id) || this.ocupado || this.cargando || this.cargandoDetalle || this.filtrosSucios || this.dialogo) return false;
      if (nuevo) return accion.nuevo === true && (!accion.configuracion || !this.total && (this.seccionConfig !== 'cajas' || tieneValor(this.filtrosAplicados.caja)));
      if (accion.orden) return this.ordenCompleto && this.ordenCambiado;
      if (accion.tabla) return this.total === this.filas.length && this.pagina === 1 && !tieneValor(this.filtrosAplicados.sucursal);
      if (accion.id === 'envio-usuario' && !this.seleccionadas.some(f => esVerdadero(f.activado))) return false;
      return accion.multiple ? this.seleccionadas.length > 0 : this.seleccionadas.length === 1;
    },
    puedeEditarRegistro(fila) {
      return !!this.accionEditarRegistro && this.contexto.auditoriaDisponible && !this.ocupado && !this.cargando &&
        !this.cargandoDetalle && !this.filtrosSucios && !this.dialogo && !this.dialogoImpresion &&
        this.filas.some(f => claveFila(this.vistaId, f) === claveFila(this.vistaId, fila));
    },
    async editarRegistro(fila) {
      if (!this.puedeEditarRegistro(fila)) return;
      const accion = this.accionEditarRegistro;
      this.elegirFila(fila);
      await this.abrirAccion(accion);
    },
    async abrirAccion(accion, nuevo = false) {
      if (!this.accionDisponible(accion, nuevo)) return;
      let reglasNuevas = null;
      if (nuevo && accion.configuracion && this.seccionConfig === 'costos-envio') {
        const token = ++this.peticionDetalle; this.cargandoDetalle = true;
        try {
          const general = await crearApi(this).consulta('config', { seccion: 'sistema', pagina: 1, tamano: 2 });
          const rangos = await crearApi(this).consulta('config', { seccion: 'precios-envio', pagina: 1, tamano: 200 });
          if (token !== this.peticionDetalle || this.destruido) return;
          if (Number(general.total) !== 1 || !Array.isArray(general.filas) || general.filas.length !== 1) throw new Error('Revise y guarde primero la configuracion General.');
          if (!Array.isArray(rangos.filas) || Number(rangos.total) !== rangos.filas.length) throw new Error('No se cargaron todos los rangos de envio.');
          reglasNuevas = { modo: general.filas[0].config_calculo_precios_envios, rangos: rangos.filas };
        } catch (error) { if (token === this.peticionDetalle && !this.destruido) this.mostrarError(error); return; }
        finally { if (token === this.peticionDetalle && !this.destruido) this.cargandoDetalle = false; }
      }
      if (!nuevo && !accion.multiple && !accion.orden && !accion.tabla && (!this.detalle || this.detalleFila !== claveFila(this.vistaId, this.seleccionadas[0]))) {
        if (!await this.verDetalle(1, false)) return;
      }
      if (!this.accionDisponible(accion, nuevo)) return;
      if (accion.id === 'turno-modificar' && esVerdadero(this.detalle && this.detalle.detalles && this.detalle.detalles.tiene_movimiento)) {
        this.mensaje = 'No puede modificar este turno porque ya tiene movimientos.'; this.tipoMensaje = 'warning';
        this.dialogoDetalle = true; return;
      }
      if (accion.configuracion && this.seccionConfig === 'costos-envio' && !nuevo) {
        const rangos = this.detalle && this.detalle.detalles && this.detalle.detalles.rangos;
        if (!rangos || !Array.isArray(rangos.filas) || rangos.total !== rangos.filas.length) {
          this.mostrarError(new Error('No se cargaron todos los rangos. Actualice el API y consulte nuevamente.')); return;
        }
      }
      this.destinatarios = clonar(nuevo ? [] : accion.orden || accion.tabla ? this.filas : this.seleccionadas.map(f => ({ ...f, ...(this.detalle && this.detalleFila === claveFila(this.vistaId, f) ? this.detalle.registro : {}) })));
      const registro = nuevo ? {} : this.destinatarios[0] || {};
      if (accion.id === 'envio-cancelar' && this.envioRecibidoYEntregado) {
        this.mensaje = 'No se puede cancelar un envio que ya fue recibido y entregado.';
        this.tipoMensaje = 'warning';
        return;
      }
      this.accion = accion; this.edicion = {}; this.motivo = ''; this.confirmarCerrado = false; this.errorAccion = ''; this.avisoFiscal = false; this.incierta = false;
      this.desmarcarAutomaticamente = false; this.excluidosAsignacion = [];
      try { this.idSolicitud = nuevoIdSolicitud(); this.firmaSolicitud = ''; }
      catch (error) { this.mostrarError(error); return; }
      if (accion.configuracion) {
        const valores = registro.valores && typeof registro.valores === 'object' ? registro.valores : registro;
        CONFIGURACION.filter(c => (CONFIG_SECCIONES[this.seccionConfig] || []).includes(c.campo)).forEach(c => {
          if (nuevo || Object.prototype.hasOwnProperty.call(valores, c.campo)) this.$set(this.edicion, c.campo, c.tipo === 'booleano' ? esVerdadero(valores[c.campo]) : tieneValor(valores[c.campo]) ? valores[c.campo] : c.tipo === 'numero' ? 0 : c.opciones ? 1 : '');
        });
        if (nuevo && this.seccionConfig === 'cajas') Object.assign(this.edicion, CONFIG_CAJA_INICIAL);
        if (this.seccionConfig === 'costos-envio') {
          if (reglasNuevas) this.$set(this.edicion, 'config_calculo_precios_envios', reglasNuevas.modo);
          this.$set(this.edicion, 'rangos', clonar(reglasNuevas ? reglasNuevas.rangos : this.detalle.detalles.rangos.filas).map(r => ({ id: r.id, minimo: r.minimo, maximo: r.maximo, porcentaje: r.porcentaje })));
        }
      } else if (accion.tabla) {
        this.$set(this.edicion, 'comisiones', this.destinatarios.map(r => ({ sucursal: r.sucursal, comision: r.comision })));
      } else {
        (accion.campos || []).forEach(c => {
          const valor = registro[c.fuente || c.campo];
          this.$set(this.edicion, c.campo, c.tipo === 'fecha' ? fechaFormulario(valor) : c.tipo === 'booleano' ? esVerdadero(valor) : simple(valor) && tieneValor(valor) ? valor : '');
        });
      }
      if (accion.id === 'turno-modificar') (accion.campos || []).forEach(c => {
        if (!(this.contexto.catalogos[c.catalogo] || []).some(o => o.activo && String(o.valor) === String(this.edicion[c.campo]))) this.edicion[c.campo] = '';
      });
      this.edicionOriginal = clonar(this.edicion);
      if (accion.id === 'envio-usuario') { this.edicion.usuario = ''; this.edicionOriginal.usuario = ''; }
      if (accion.id === 'turnos-reordenar') this.edicion.turno = this.filtrosAplicados.turno || this.filtrosAplicados.id || registro.turno || '';
      this.dialogoDetalle = false; this.dialogo = true;
      if (accion.configuracion && this.seccionConfig === 'cajas') await this.cargarImpresoras();
    },
    cerrarAccion() { if (!this.guardando) { this.dialogo = false; this.accion = null; } },
    construirAccion() {
      const accion = this.accion;
      if (!accion || !this.acciones.some(a => a.id === accion.id) || !this.disponible(this.vistaId)) throw new Error('No tiene permiso para esta accion.');
      if (!this.contexto.auditoriaDisponible) throw new Error('Falta aplicar la migracion de auditoria. Las modificaciones estan bloqueadas.');
      if (accion.id === 'envio-usuario') {
        this.aplicarDesmarcado();
        if (!this.usuarioDestinoAsignacion) throw new Error('Seleccione un cajero destino activo.');
        if (!this.destinatarios.length) throw new Error('No quedan envios seleccionados para asignar.');
      }
      if (accion.id === 'envio-cancelar' && this.envioRecibidoYEntregado) throw new Error('No se puede cancelar un envio que ya fue recibido y entregado.');
      const motivo = this.motivo.trim();
      if (motivo.length < 5 || motivo.length > 1000) throw new Error('Especifique un motivo de 5 a 1000 caracteres.');
      if (accion.id !== 'envio-usuario' && this.cierreAfectado && !this.confirmarCerrado) throw new Error('Confirme la advertencia sobre el cierre guardado.');
      const body = { motivo, confirmarCerrado: this.confirmarCerrado === true };
      const registro = this.destinatarios[0] || {};
      if (accion.orden || accion.multiple) {
        body.ids = this.destinatarios.map(f => identidad(this.vistaId, f));
        if (!body.ids.length || body.ids.some(id => !tieneValor(id)) || new Set(body.ids.map(String)).size !== body.ids.length) throw new Error('La seleccion contiene identificadores invalidos o duplicados.');
        if (accion.orden && body.ids.length !== this.total) throw new Error('Debe cargar el orden completo antes de guardar.');
      } else if (!accion.configuracion && !accion.tabla && (!accion.nuevo || this.destinatarios.length)) {
        const id = identidad(this.vistaId, registro);
        if (!tieneValor(id)) throw new Error('Seleccione un registro valido.');
        body[accion.id === 'envio-cancelar' ? 'noEnvio' : 'id'] = accion.id === 'envio-cancelar' ? registro.no_envio || registro.noEnvio : id;
        if (!tieneValor(body[accion.id === 'envio-cancelar' ? 'noEnvio' : 'id'])) throw new Error('El registro no tiene identificador de envio.');
      }
      const valores = {};
      this.camposAccion.forEach(c => {
        let valor = this.edicion[c.campo];
        if (accion.registro && String(valor == null ? '' : valor) === String(this.edicionOriginal[c.campo] == null ? '' : this.edicionOriginal[c.campo])) return;
        if (c.requerido && !tieneValor(valor)) throw new Error('Debe indicar: ' + c.titulo);
        if (!tieneValor(valor) && !accion.configuracion && !accion.registro) return;
        if (c.tipo === 'booleano') valor = esVerdadero(valor);
        else if (c.tipo === 'fecha') {
          if (tieneValor(valor) && (!fechaValida(valor) || Number(String(valor).slice(0, 4)) < 1)) throw new Error('Fecha invalida: ' + c.titulo);
          if (!tieneValor(valor)) valor = null;
        }
        else if (c.tipo === 'numero') {
          if (!tieneValor(valor) || !Number.isFinite(Number(valor)) || c.min !== undefined && Number(valor) < c.min || c.max !== undefined && Number(valor) > c.max || c.entero && !Number.isInteger(Number(valor))) throw new Error('Valor invalido: ' + c.titulo);
          valor = Number(valor);
        } else if (typeof valor === 'string') {
          valor = valor.trim(); if (valor.length > (c.maxlength || (c.tipo === 'textarea' ? 4000 : 300))) throw new Error('Texto demasiado largo: ' + c.titulo);
          if (c.requerido && !valor) throw new Error('Debe indicar: ' + c.titulo);
        }
        if (!simple(valor)) throw new Error('Valor invalido: ' + c.titulo);
        const opciones = c.catalogo ? this.contexto.catalogos[c.catalogo] || [] : c.opciones || [];
        if (c.tipo !== 'combobox' && (c.catalogo || opciones.length) && tieneValor(valor) && !opciones.some(o => String(o.valor) === String(valor))) throw new Error('Seleccione una opcion valida: ' + c.titulo);
        valores[c.campo] = valor;
      });
      if (accion.id === 'ticket-usuario' && !tieneValor(valores.usuarioVenta) && !tieneValor(valores.usuarioLectura)) throw new Error('Seleccione al menos un usuario de venta o lectura.');
      if (accion.configuracion) {
        if (!Object.keys(valores).length) throw new Error('El servidor no devolvio campos de configuracion editables.');
        body.seccion = this.seccionConfig === 'cajas' ? 'caja' : this.seccionConfig;
        if (body.seccion === 'caja') body.caja = registro.idcaja || this.filtrosAplicados.caja;
        if (body.seccion === 'caja' && !tieneValor(body.caja)) throw new Error('Seleccione la caja de la configuracion.');
        body.valores = valores;
        if (body.seccion === 'sistema' && !this.destinatarios.length) valores.config_calculo_precios_envios = 1;
        if (body.seccion === 'costos-envio') {
          body.modoCalculo = valores.config_calculo_precios_envios;
          delete valores.config_calculo_precios_envios;
          if (Array.isArray(this.edicion.rangos) && JSON.stringify(this.edicion.rangos) !== JSON.stringify(this.edicionOriginal.rangos)) {
            body.rangos = this.validarTablaConfiguracion('rangos', this.edicion.rangos);
          }
        }
      } else if (accion.tabla) body.filas = this.validarTablaConfiguracion('comisiones', this.edicion.comisiones || []);
      else if (accion.valores) {
        if (accion.id === 'config-rango-guardar' && valores.minimo > valores.maximo) throw new Error('El minimo no puede superar el maximo.');
        if (accion.registro && !Object.keys(valores).length) throw new Error('No hay cambios para guardar.');
        if (accion.id === 'cortesia-guardar' && Object.prototype.hasOwnProperty.call(valores, 'cantidad')) {
          const consumidas = Number(registro.cantidad) - Number(registro.cantidad_restante);
          if (Number.isFinite(consumidas) && valores.cantidad < consumidas) throw new Error('La cantidad no puede ser menor que las cortesias ya utilizadas.');
        }
        body.valores = valores;
      } else Object.assign(body, valores);
      if (accion.id === 'turno-modificar' && ['vehiculo', 'chofer'].every(k => String(this.edicion[k]) === String(this.edicionOriginal[k]))) throw new Error('No hay cambios para guardar.');
      return body;
    },
    validarTablaConfiguracion(tipo, filas) {
      if (filas.length > 200) throw new Error('La tabla supera el limite de 200 filas.');
      const resultado = filas.map(f => {
        const r = {};
        (tipo === 'rangos' ? ['minimo', 'maximo', 'porcentaje'] : ['sucursal', 'comision']).forEach(k => {
          if (!tieneValor(f[k]) || !Number.isFinite(Number(f[k])) || Number(f[k]) < 0) throw new Error('Valor invalido en ' + tipo + ': ' + k);
          r[k] = Number(f[k]);
        });
        if (tipo === 'rangos' && (r.minimo > r.maximo || r.porcentaje > 100)) throw new Error('Revise los limites y porcentajes de los rangos.');
        if (tipo === 'comisiones' && !(this.contexto.catalogos.sucursales || []).some(s => String(s.valor) === String(r.sucursal))) throw new Error('Seleccione una sucursal valida.');
        if (tipo === 'rangos' && tieneValor(f.id)) r.id = f.id;
        return r;
      });
      if (tipo === 'rangos') {
        const orden = resultado.slice().sort((a, b) => a.minimo - b.minimo);
        if (orden.some((r, i) => i && r.minimo <= orden[i - 1].maximo)) throw new Error('Los rangos no pueden superponerse.');
      } else if (new Set(resultado.map(r => r.sucursal)).size !== resultado.length) throw new Error('La sucursal no puede repetirse.');
      return resultado;
    },
    async confirmarAccion() {
      if (this.guardando || !this.dialogo) return;
      let body;
      try {
        body = this.construirAccion();
        const firma = JSON.stringify([this.accion.id, body]);
        if (this.firmaSolicitud && firma !== this.firmaSolicitud) this.idSolicitud = nuevoIdSolicitud();
        if (!this.idSolicitud) this.idSolicitud = nuevoIdSolicitud();
        this.firmaSolicitud = firma; body.idSolicitud = this.idSolicitud;
      } catch (error) { this.errorAccion = textoError(error); return; }
      this.guardando = true; this.errorAccion = ''; this.avisoFiscal = false;
      let respuesta, avisoCatalogos = '';
      try {
        respuesta = await crearApi(this).accion(this.accion.id, body);
        if (respuesta.pendienteFiscal) {
          this.avisoFiscal = respuesta.estado === 'EN_PROCESO';
          this.errorAccion = this.avisoFiscal
            ? `Pendiente de respuesta de la DGII. La nota de credito ${respuesta.ncfDevolucion || ''} ya fue enviada, pero aun no tiene aceptacion confirmada. El documento y su factura siguen activos. Puede consultar el estado de la misma nota sin crear otra devolucion.`
            : respuesta.mensaje;
          this.incierta = true;
          respuesta = null;
          return;
        }
        if (['fichas', 'personas'].includes(this.vistaId)) {
          try { this.contexto = normalizarContexto(await crearApi(this).contexto()); }
          catch (error) {
            this.revocarSiDenegado(error);
            avisoCatalogos = ' No se pudieron actualizar los catalogos; recargue el Utilitario.';
          }
        }
        this.dialogo = false; this.accion = null;
      } catch (error) {
        this.incierta = !error.response || error.response.status >= 500;
        this.errorAccion = textoError(error) + (this.incierta ? ' El resultado no esta confirmado. Reintentar sin cambios conserva el identificador de la solicitud.' : '');
        this.revocarSiDenegado(error);
      } finally { this.guardando = false; }
      if (respuesta) {
        const exito = respuesta.mensaje || 'Operacion completada.';
        const asignacion = this.vistaId === 'arreglos-envios' && Array.isArray(respuesta.resultadosEnvios);
        if (asignacion) this.resultadosAsignacion = [...respuesta.resultadosEnvios, ...this.excluidosAsignacion];
        const actualizado = await this.consultar(this.pagina, false);
        this.mensaje = exito + avisoCatalogos + (actualizado ? '' : ' No se pudo actualizar el listado. Consulte nuevamente.');
        this.tipoMensaje = actualizado && !avisoCatalogos && !(asignacion && (Number(respuesta.omitidos) || this.excluidosAsignacion.length)) ? 'success' : 'warning';
      }
    },
    mover(indice, paso) {
      if (!this.contexto.auditoriaDisponible || !this.ordenCompleto || this.ocupado || this.cargando || this.dialogo || this.filtrosSucios || !this.permisos.corregir || !this.soloOrden) return;
      const destino = indice + paso;
      if (destino < 0 || destino >= this.filas.length) return;
      const filas = this.filas.slice(); const actual = filas.splice(indice, 1)[0]; filas.splice(destino, 0, actual);
      this.filas = filas; this.ordenCambiado = true;
    },
    async abrirImpresion(modo = 'documento') {
      if (this.ocupado || (modo === 'listado' ? !this.puedeReporte : !this.puedeReimprimir)) return;
      this.modoImpresion = modo; this.formatoImpresion = this.formatosImpresion.length ? this.formatosImpresion[0].valor : '';
      if (modo === 'listado' && this.vistaId === 'envios') this.formatoImpresion = ({ usuario: 'ListadoDetalladoPaquetesPorSucursalYUsuario', cliente: 'ListadoDetalladoPaquetesPorCliente', sucursal: 'ListadoDetalladoPaquetesPorSucursal' })[this.filtrosAplicados.agrupacion] || 'ListadoDetalladoPaquetes';
      this.salidaImpresion = modo === 'listado' ? 'preview' : 'print'; this.enviarDirecto = false; this.copias = 0;
      this.impresora = ajustesImpresora(localStorage); this.errorImpresion = ''; this.impresionIncierta = false;
      this.requiereSinQr = false; this.confirmarSinQr = false;
      this.dialogoImpresion = true;
      if (!(modo === 'listado' && this.vistaId === 'tickets')) await this.cargarImpresoras();
    },
    async cargarImpresoras() {
      if (this.cargandoImpresoras || this.imprimiendo) return;
      this.cargandoImpresoras = true;
      try {
        const terminal = await listarImpresoras(this.$axios); this.impresoras = terminal.impresoras;
        this.impresoraPredeterminada = terminal.predeterminada; this.impresorasCargadas = true; this.errorImpresion = '';
        if (this.impresora && !this.impresoras.some(i => i.nombre === this.impresora)) { this.impresora = null; this.errorImpresion = 'La impresora guardada no esta registrada en Windows. Seleccione una impresora o la predeterminada.'; }
        else if (this.impresora === '' && this.impresoras.some(i => i.nombre === terminal.predeterminada)) this.impresora = terminal.predeterminada;
        if (!this.impresoras.length) this.errorImpresion = 'Windows no tiene impresoras registradas disponibles.';
      }
      catch (error) { this.errorImpresion = 'No se pudo consultar el servicio local de impresoras. ' + textoError(error); }
      finally { this.cargandoImpresoras = false; }
    },
    async imprimirDocumento() {
      if (!this.dialogoImpresion || this.imprimiendo || this.impresionIncierta || !this.puedeImprimir) return;
      if (this.requiereSinQr && !this.confirmarSinQr) { this.errorImpresion = 'Confirme expresamente la reimpresion sin QR para continuar.'; return; }
      if (this.salidaImpresion !== 'preview' && this.impresora === null) { this.errorImpresion = 'Seleccione una impresora.'; return; }
      if (this.salidaImpresion !== 'preview' && this.impresorasCargadas && this.impresora && !this.impresoras.some(i => i.nombre === this.impresora)) { this.errorImpresion = 'La impresora seleccionada no esta registrada en Windows. Actualice la lista.'; return; }
      if (!Number.isInteger(Number(this.copias)) || Number(this.copias) < 0 || Number(this.copias) > 9) { this.errorImpresion = 'Las copias adicionales deben estar entre 0 y 9.'; return; }
      this.imprimiendo = true; this.errorImpresion = '';
      let envioLocalIniciado = false;
      try {
        const fila = this.seleccionadas[0];
        const body = { modo: this.modoImpresion, impresora: this.impresora || '', accion: this.salidaImpresion, enviarDirecto: this.salidaImpresion === 'print' && this.enviarDirecto, copias: Number(this.copias) };
        if (this.modoImpresion === 'listado') {
          body.filtros = { ...this.filtrosAplicados }; delete body.filtros.pagina; delete body.filtros.tamano;
          if (this.formatosImpresion.length) {
            if (!this.formatosImpresion.some(f => f.valor === this.formatoImpresion)) throw new Error('Seleccione un formato de reporte valido.');
            body.formato = this.formatoImpresion;
          }
          // Los reportes sin selector, incluida Produccion, se resuelven en la API
          // a partir de los filtros aplicados (tipo y resumido), no de otra vista.
        } else {
          body.id = this.vistaId === 'cierres-caja' ? fila.secuencia : identidad(this.vistaId, fila);
          if (['tickets', 'envios'].includes(this.vistaId) && this.requiereSinQr && this.confirmarSinQr) body.confirmarSinQr = true;
          if (tieneValor(fila.caja || this.filtrosAplicados.caja)) body.caja = fila.caja || this.filtrosAplicados.caja;
        }
        if (this.modoImpresion === 'listado' && this.vistaId === 'tickets') {
          this.reportePdfBlob = await crearApi(this).reporteTicketsPdf(body);
          this.dialogoImpresion = false; this.dialogoReportePdf = true;
          return;
        }
        const data = await crearApi(this).impresion(this.vistaId, body);
        if (['tickets', 'envios'].includes(this.vistaId) && this.modoImpresion === 'documento' && data && data.requiereConfirmacionSinQr === true) {
          this.requiereSinQr = true; this.confirmarSinQr = false;
          this.errorImpresion = data.mensaje || 'El comprobante aun no tiene QR. Confirme si desea reimprimirlo sin QR.';
          return;
        }
        if (!data || typeof data.operacion !== 'string' || !data.payload || Array.isArray(data.payload) || typeof data.payload !== 'object') throw new Error('El servidor no devolvio un documento de impresion valido.');
        if (this.modoImpresion === 'listado' && data.operacion !== 'utilitario-transporte') throw new Error('El servidor no devolvio el listado solicitado. Actualice la API antes de imprimir.');
        const payload = { ...data.payload, operacion: data.operacion, impresora: this.impresora || '' };
        if (this.modoImpresion === 'listado') delete payload.schema;
        else payload.schema = crearApi(this).headers()['X-TENANT-ID'];
        envioLocalIniciado = true;
        await postImpresoraLocal(this.$axios, payload);
        this.dialogoImpresion = false; this.mensaje = this.salidaImpresion === 'preview' ? 'Vista previa enviada al servicio local.' : 'Documento enviado al servicio de impresion.'; this.tipoMensaje = 'success';
      } catch (error) {
        this.impresionIncierta = envioLocalIniciado && ['ECONNABORTED', 'ETIMEDOUT'].includes(error.code);
        const sinConexion = !error.response && (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED' || error.message === 'Network Error');
        let mensaje = textoError(error);
        if (error.response && error.response.data instanceof Blob) {
          const texto = await error.response.data.text();
          try { const datos = JSON.parse(texto); mensaje = datos.message || datos.error || mensaje; }
          catch (_) { mensaje = texto || mensaje; }
        }
        if (sinConexion) mensaje = envioLocalIniciado
          ? 'No se pudo conectar con el programa de impresora de esta PC (puerto 15999). Abra el programa de impresora y vuelva a intentar. La vista previa tambien requiere ese programa.'
          : 'No se pudo conectar con el API para obtener los datos del reporte. Revise la conexion con el servidor y vuelva a intentar. No se envio al programa de impresora.';
        this.errorImpresion = mensaje + (this.impresionIncierta ? ' Puede haberse impreso. Verifique la impresora antes de reimprimir; no se reenviara automaticamente.' : '');
        this.revocarSiDenegado(error);
      } finally { this.imprimiendo = false; }
    },
    exportarCsv() {
      if (this.ocupado || this.cargando || this.filtrosSucios || !this.disponible(this.vistaId) || !this.filas.length) return;
      const url = URL.createObjectURL(new Blob([csv(this.meta.columnas, this.filas)], { type: 'text/csv;charset=utf-8;' }));
      const enlace = document.createElement('a'); enlace.href = url; enlace.download = this.vistaId + '-pagina-' + this.pagina + '.csv';
      document.body.appendChild(enlace); enlace.click(); enlace.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
    imprimirListado() {
      if (!this.ocupado && !this.cargando && !this.filtrosSucios && this.disponible(this.vistaId) && this.filas.length) window.print();
    },
    async cargarAuditoria(pagina = 0) {
      if (this.cargandoAuditoria || this.ocupado || !this.permisos.configurar || !this.contexto.auditoriaDisponible) return;
      this.dialogoAuditoria = true; this.cargandoAuditoria = true; this.errorAuditoria = '';
      try {
        const data = await crearApi(this).auditoria(Math.max(0, pagina));
        if (!data || !Array.isArray(data.filas)) throw new Error('La respuesta de auditoria no es valida.');
        this.auditoriaFilas = data.filas; this.auditoriaPagina = pagina; this.auditoriaTotal = Number(data.total) || data.filas.length;
      } catch (error) { this.errorAuditoria = textoError(error); this.revocarSiDenegado(error); }
      finally { this.cargandoAuditoria = false; }
    },
    revocarSiDenegado(error) {
      if (error && error.response && [401, 403].includes(error.response.status)) {
        this.contexto.permisos = {}; this.contextoListo = false; this.limpiarSeleccion(); this.resultadosAsignacion = []; this.filas = []; this.total = 0; this.resumen = null; this.invalidarDetalle();
        this.campoTurno = ''; this.turnosSeleccionados = {};
      }
    },
    mostrarError(error) { this.mensaje = textoError(error); this.tipoMensaje = 'error'; this.revocarSiDenegado(error); },
  },
};
